$(function () {

    /* *********************************************************************** */

    /*
   * Forms
   */

    DECIX.functions.formSetup = function (form) {

        var $form = $(form);

        $form.each(function () {

            var $this = $(this);

            $this.find(".form-control.select").selectpicker({
                size: 10
            });

        });

    };

    DECIX.functions.formSetup("form");

});
